package com.partejar.app.feature.contratos.data

data class Contrato(
    val id: Long,
    val patientId: Long,
    val status: String,
    val planVersionId: Long?,
    val modelVersionId: Long?,
    val signerIds: List<Long>,
    val content: String?,
    val pendingFields: List<String>,
    val dueDate: String? = null,
    val babyName: String? = null,
    val planName: String? = null,
    val planPrice: String? = null,
    val modelName: String? = null,
    val signerNames: List<String> = emptyList(),
    val generatedAt: String? = null,
    val documentHash: String? = null
) { val isFrozen get() = status in setOf("PRONTO_PARA_ASSINATURA", "AGUARDANDO_ASSINATURA_PACIENTE", "AGUARDANDO_ASSINATURAS_EQUIPE", "ASSINADO") }
data class ContratoOptions(val plans: List<ContractPlan>, val models: List<ContractModel>, val signers: List<ContractSigner>)
data class ContractPlan(val versionId: Long, val name: String, val price: String, val services: List<String>)
data class ContractModel(val versionId: Long, val name: String)
data class ContractSigner(val memberId: Long, val name: String, val category: String, val registration: String?)
data class CivilData(val patientName: String, val cpf: String?, val email: String?)
data class ContractConfiguration(val patientId: Long, val planVersionId: Long, val modelVersionId: Long, val signerIds: List<Long>)
data class SignatureLink(val url: String, val expiresAt: String, val expiresAtInstant: String? = null)
data class ContractSignatures(val status: String, val canCurrentMemberSign: Boolean, val patient: SignatureItem, val team: List<SignatureItem>)
data class SignatureItem(val memberId: Long?, val name: String, val signed: Boolean, val signedAt: String?)
data class PublicContract(val patientName: String, val workspaceName: String, val content: String, val documentHash: String, val expiresAt: String, val status: String)
data class ContractPdf(val bytes: ByteArray, val filename: String)

interface ContratosDataSource {
    suspend fun start(patientId: Long): Contrato
    suspend fun get(id: Long): Contrato
    suspend fun options(): ContratoOptions
    suspend fun configure(id: Long, configuration: ContractConfiguration): Contrato
    suspend fun civil(id: Long): CivilData
    suspend fun updateCivil(id: Long, cpf: String, email: String): CivilData
    suspend fun generate(id: Long): Contrato
    suspend fun cancel(id: Long): Contrato
    suspend fun createSignatureLink(id: Long): SignatureLink = error("Assinaturas não disponíveis")
    suspend fun signatures(id: Long): ContractSignatures = error("Assinaturas não disponíveis")
    suspend fun signAsTeam(id: Long, documentHash: String, signatureStrokes: String): ContractSignatures = error("Assinaturas não disponíveis")
    suspend fun publicContract(token: String): PublicContract = error("Assinaturas não disponíveis")
    suspend fun signPublic(token: String, documentHash: String, signatureStrokes: String): PublicContract = error("Assinaturas não disponíveis")
    suspend fun pdf(id: Long): ContractPdf = error("PDF não disponível")
    suspend fun publicPdf(token: String): ContractPdf = error("PDF não disponível")
}
